<template>
  <div class="empleados-wrapper">
    <ModalLoading :isLoading="isLoading" />

    <div class="opciones">
      <button
        v-if="puedeCrearUsuario"
        id="btnAdd"
        class="btn btn-primary"
        @click="openModal"
        style="width: 200px; white-space: nowrap"
      >
        Agregar Usuario
      </button>

      <div class="search-bar">
        <input
          class="busqueda"
          type="text"
          v-model="searchQuery"
          placeholder="Buscar empleado..."
        />
      </div>

      <div class="registros" v-if="sucursales.length > 1">
        <span>
          <select class="custom-select" v-model="searchSucursal">
            <option value="default" selected>Todas</option>
            <option
              v-for="(sucursal, index) in this.sucursales"
              :key="index"
              :value="sucursal.id_sucursal"
            >
              {{ sucursal.nombre_administrativo }}
            </option>
          </select>
        </span>
      </div>
    </div>

    <div class="table-container">
      <div v-if="isLoading" class="loading-indicator">
        Cargando empleados...
      </div>

      <div v-else-if="paginatedEmpleados.length === 0" class="no-data">
        No se encontraron empleados para mostrar.
      </div>

      <table v-else class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Nombre Usuario</th>
            <th>Teléfono</th>
            <th>Email</th>
            <th>Rol</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(empleado, index) in paginatedEmpleados" :key="index">
            <td data-label="#">
              {{ (currentPage - 1) * pageSize + index + 1 }}
            </td>
            <td data-label="Nombre">{{ empleado.nombre }}</td>
            <td data-label="Apellido">{{ empleado.apellido }}</td>
            <td data-label="Nombre Usuario">{{ empleado.nombre_usuario }}</td>
            <td data-label="Teléfono">{{ empleado.telefono }}</td>
            <td data-label="Email">{{ empleado.correo }}</td>
            <td data-label="Rol">{{ getRol(empleado.id_rol) }}</td>
            <td data-label="Acciones">
              <button
                v-if="puedeEditarUsuario"
                class="accion-btn accion-editar"
                @click="editEmpleado(empleado)"
                title="Editar empleado"
              >
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button
                v-if="puedeEliminarUsuario"
                class="accion-btn accion-eliminar"
                @click="deleteUsuariol(empleado)"
                title="Desactivar empleado"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-wrapper">
        <div class="pagination-info">
          Mostrando {{ (currentPage - 1) * pageSize + 1 }} a
          {{ Math.min(currentPage * pageSize, filteredEmpleados.length) }} de
          {{ filteredEmpleados.length }} registros
        </div>
        <div class="pagination-container">
          <button
            class="pagination-button"
            :disabled="currentPage === 1"
            @click="previousPage"
          >
            Anterior
          </button>
          <button
            class="pagination-button"
            :disabled="currentPage === totalPages"
            @click="nextPage"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>

    <div class="modal" v-if="showConfirmModal">
      <div class="modal-confirm">
        <div class="modal-header">
          <h2>Confirmación</h2>
        </div>
        <div class="modal-body-confirm">
          <p>¿Estás seguro de que quieres eliminar este usuario?</p>
        </div>
        <div class="modal-footer">
          <div class="action-buttons">
            <btnGuardarModal
              texto="Sí, eliminar"
              style="background-color: red"
              @click="deleteUsuariol(empleado)"
            />
            <btnCerrarModal texto="No, regresar" @click="cancelDelete" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="isModalOpen" class="modal">
      <div class="modal-usuario">
        <div class="modal-header">
          <h2 class="h2-modal-content">
            {{ isEditing ? "Editar Usuario" : "Agregar Usuario" }}
          </h2>
        </div>

        <div class="modal-body">
          <div class="contenedor contenedor-izquierdo">
            <div class="form-group">
              <label>Nombre:</label>
              <input
                ref="nombreInput"
                v-model="usuarioForm.nombre"
                type="text"
                required
              />
            </div>

            <div class="form-group">
              <label>Apellido:</label>
              <input v-model="usuarioForm.apellido" type="text" required />
            </div>

            <div class="form-group">
              <label>Nombre de Usuario:</label>
              <input
                v-model="usuarioForm.nombre_usuario"
                type="text"
                required
              />
            </div>

            <div class="form-group">
              <label>Correo:</label>
              <input v-model="usuarioForm.correo" type="text" required />
            </div>

            <div class="form-group">
              <label for="rol">Selecciona rol:</label>
              <select
                class="form-select"
                id="rol"
                name="rol"
                value="default"
                v-model="usuarioForm.rol"
                required
              >
                <option value="" disabled selected>Selecciona un rol</option>
                <option
                  v-for="(rol, index) in roles"
                  :key="index"
                  :value="rol.id_rol"
                >
                  {{ rol.cargo }}
                </option>
              </select>
            </div>
          </div>

          <div class="contenedor contenedor-derecho" :class="{ 'contenedor-con-permisos': mostrarPermisos }">
            <div class="form-group">
              <label>
                <span
                  class="info-icon"
                  @mouseover="showTooltip = true"
                  @mouseleave="showTooltip = false"
                  >ℹ️</span
                >
                Contraseña:
              </label>
              <div class="password-wrapper">
                <input
                  v-model="usuarioForm.password"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  :disabled="!isPassEdit"
                />
                <button
                  type="button"
                  class="toggle-password"
                  @click="showPassword = !showPassword"
                  :disabled="!isPassEdit"
                >
                  <i
                    :class="
                      showPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'
                    "
                  ></i>
                </button>
              </div>
              <div v-if="showTooltip" class="tooltip">
                La contraseña debe tener al menos 8 caracteres, incluir una
                letra mayúscula, una letra minúscula, un número y un símbolo.
              </div>
            </div>

            <div class="form-group">
              <label>Confirmar contraseña:</label>
              <div class="password-wrapper">
                <input
                  v-model="usuarioForm.confirmPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  required
                  :disabled="!isPassEdit"
                />
                <button
                  type="button"
                  class="toggle-password"
                  @click="showConfirmPassword = !showConfirmPassword"
                  :disabled="!isPassEdit"
                >
                  <i
                    :class="
                      showConfirmPassword
                        ? 'bi bi-eye-slash-fill'
                        : 'bi bi-eye-fill'
                    "
                  ></i>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label>Teléfono:</label>
              <div class="phone-input-container">
                <select
                  v-model="selectedCountry"
                  @change="updatePhoneValidation"
                  class="select-phone"
                >
                  <option value="">País</option>
                  <option
                    v-for="(country, code) in countryData"
                    :key="code"
                    :value="code"
                  >
                    {{ country.emoji }} {{ country.code }}
                  </option>
                </select>
                <input
                  v-model="usuarioForm.telefono"
                  type="text"
                  class="input-phone"
                  :placeholder="'Número (' + phoneLength + ' dígitos)'"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label>Dirección:</label>
              <input v-model="usuarioForm.direccion" type="text" required />
            </div>

            <div class="form-group" v-if="sucursales.length > 1">
              <label for="sucursal">Selecciona sucursal:</label>
              <select
                class="form-select"
                id="sucursal"
                name="sucursal"
                value="default"
                v-model="usuarioForm.sucursal"
                required
              >
                <option value="" disabled selected>
                  Selecciona una sucursal
                </option>
                <option
                  v-for="(sucursal, index) in sucursales"
                  :key="index"
                  :value="sucursal.id_sucursal"
                >
                  {{ sucursal.nombre_administrativo }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- PERMISOS SECTION — Cajero: solo acciones de VentasList -->
        <div v-if="mostrarPermisos && esCajero" class="permisos-section">
          <h3 class="permisos-titulo">Permisos del Cajero</h3>
          <p class="permisos-desc">El cajero solo accede a la pantalla de Ventas. Controla qué acciones puede realizar.</p>
          <div class="permisos-grid">
            <div v-for="accion in ACCIONES_CAJERO" :key="accion.key" class="permiso-modulo">
              <label class="permiso-modulo-label">
                <input type="checkbox" v-model="usuarioForm.permisos.acciones[accion.key]" class="permiso-check" />
                <span>{{ accion.label }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- PERMISOS SECTION — Admin/Admin empleado: módulos + acciones -->
        <div v-if="mostrarPermisos && !esCajero" class="permisos-section">
          <h3 class="permisos-titulo">Permisos del Usuario</h3>
          <p class="permisos-desc">Controla a qué módulos y acciones tiene acceso este usuario.</p>
          <div class="permisos-grid">
            <div v-for="modulo in MODULOS_PERMISOS" :key="modulo.key" class="permiso-modulo">
              <label class="permiso-modulo-label">
                <input type="checkbox" v-model="usuarioForm.permisos.modulos[modulo.key]" class="permiso-check" />
                <span>{{ modulo.label }}</span>
              </label>
              <div v-if="usuarioForm.permisos.modulos[modulo.key] && modulo.acciones.length > 0" class="permiso-acciones">
                <label v-for="accion in modulo.acciones" :key="accion.key" class="permiso-accion-label">
                  <input type="checkbox" v-model="usuarioForm.permisos.acciones[accion.key]" class="permiso-check" />
                  <span>{{ accion.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="action-buttons">
            <btnGuardarModal
              :texto="isEditing ? 'Guardar Cambios' : 'Agregar Usuario'"
              @click="guardarUsuario"
              type="submit"
            >
            </btnGuardarModal>
            <btnCerrarModal
              :texto="'Cerrar'"
              @click="closeModal"
            ></btnCerrarModal>
          </div>
          <button
            class="btn editar-password"
            :disabled="!isEditing"
            @click="editarPassword"
          >
            Editar Contraseña
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import btnGuardarModal from "../components/botones/modales/btnGuardar.vue";
import btnCerrarModal from "../components/botones/modales/btnCerrar.vue";
import solicitudes from "../../services/solicitudes.js";
import { hasAccionPermiso } from '../../services/permisos.js';
import { notis } from "../../services/notificaciones.js";
const {
  esCeo,
  getUsuariosEmpresa,
  getRolesUsuarioPage,
  getUsuariosSucrusal,
} = require("../../services/usuariosSolicitudes");
import { getSucursalesbyEmmpresaSumm } from "../../services/sucursalesSolicitudes.js";
import { COUNTRY_CODES } from "../../services/countrySelector.js";
import { validacionesUsuario } from "../../services/validarCampos.js";
import ModalLoading from "@/components/ModalLoading.vue";
import { setPageTitle } from "@/components/pageMetadata";
const { getSocket } = require('@/services/socket');

const ACCIONES_CAJERO = [
  { key: 'ventas_descuento_producto', label: 'Aplicar descuento por producto [F8]' },
  { key: 'ventas_descuento_general',  label: 'Aplicar descuento general [F9]' },
  { key: 'ventas_nc',                 label: 'Aplicar Nota de Crédito (NC)' },
  { key: 'ventas_cotizaciones',       label: 'Ver cotizaciones pendientes' },
  { key: 'ventas_crear_cliente',      label: 'Crear cliente nuevo' },
];

const MODULOS_PERMISOS = [
  { key: 'Venta', label: 'Ventas', acciones: [
    { key: 'ventas_descuento_general',  label: 'Aplicar descuento general [F9]' },
    { key: 'ventas_descuento_producto', label: 'Aplicar descuento por producto [F8]' },
    { key: 'ventas_nc',                 label: 'Aplicar Nota de Crédito' },
    { key: 'ventas_cotizaciones',       label: 'Ver cotizaciones pendientes' },
    { key: 'ventas_crear_cliente',      label: 'Crear cliente nuevo en caja' },
  ]},
  { key: 'Compra', label: 'Compras', acciones: [
    { key: 'compras_crear', label: 'Registrar compra' },
  ]},
  { key: 'Productos', label: 'Productos', acciones: [
    { key: 'productos_crear',    label: 'Crear producto' },
    { key: 'productos_editar',   label: 'Editar producto' },
    { key: 'productos_eliminar', label: 'Desactivar producto' },
  ]},
  { key: 'Categorias', label: 'Categorías', acciones: [
    { key: 'categorias_crear',    label: 'Crear categoría' },
    { key: 'categorias_editar',   label: 'Editar categoría' },
    { key: 'categorias_eliminar', label: 'Eliminar categoría' },
  ]},
  { key: 'Clientes', label: 'Clientes', acciones: [
    { key: 'clientes_crear',    label: 'Crear cliente' },
    { key: 'clientes_editar',   label: 'Editar cliente' },
    { key: 'clientes_eliminar', label: 'Eliminar cliente' },
  ]},
  { key: 'Proveedores', label: 'Proveedores', acciones: [
    { key: 'proveedores_crear',    label: 'Crear proveedor' },
    { key: 'proveedores_editar',   label: 'Editar proveedor' },
    { key: 'proveedores_eliminar', label: 'Eliminar proveedor' },
  ]},
  { key: 'Cotizaciones', label: 'Cotizaciones', acciones: [
    { key: 'cotizaciones_crear',     label: 'Crear cotización' },
    { key: 'cotizaciones_gestionar', label: 'Aceptar / Rechazar cotización' },
  ]},
  { key: 'ArqueoCaja',       label: 'Arqueo de Caja',     acciones: [] },
  { key: 'CuentasPorPagar',  label: 'Cuentas por Pagar',  acciones: [
    { key: 'cxp_pagar', label: 'Registrar pago de cuenta' },
  ]},
  { key: 'CuentasPorCobrar', label: 'Cuentas por Cobrar', acciones: [
    { key: 'cxc_cobrar', label: 'Registrar cobro de cuenta' },
  ]},
  { key: 'Devoluciones', label: 'Devoluciones / NC', acciones: [
    { key: 'devoluciones_crear', label: 'Crear devolución / anulación' },
  ]},
  { key: 'Nomina', label: 'Planilla', acciones: [
    { key: 'nomina_generar', label: 'Generar planilla del mes' },
    { key: 'nomina_pagar',   label: 'Registrar / confirmar pago' },
    { key: 'nomina_eliminar',label: 'Eliminar registro de pago' },
  ]},
  { key: 'LibrosFiscales', label: 'Libros Fiscales', acciones: [] },
  { key: 'Auditoria',      label: 'Auditoría',        acciones: [] },
  { key: 'Usuario', label: 'Gestión de Usuarios', acciones: [
    { key: 'usuarios_crear',    label: 'Crear usuario' },
    { key: 'usuarios_editar',   label: 'Editar usuario' },
    { key: 'usuarios_eliminar', label: 'Desactivar usuario' },
  ]},
  { key: 'Sucursal', label: 'Sucursales', acciones: [
    { key: 'sucursales_crear',    label: 'Crear sucursal' },
    { key: 'sucursales_editar',   label: 'Editar sucursal' },
    { key: 'sucursales_eliminar', label: 'Eliminar sucursal' },
  ]},
];

// Rol 1 — Admin: total excepto Sucursales (solo CEO)
const MODULOS_ADMIN = {
  Home:true, Venta:true, Compra:true, Productos:true, Categorias:true,
  Clientes:true, Proveedores:true, Cotizaciones:true, ArqueoCaja:true,
  CuentasPorPagar:true, CuentasPorCobrar:true, Devoluciones:true,
  Nomina:true, LibrosFiscales:true, Auditoria:true, Usuario:true,
  Sucursal:false, reporte:true,
};
const ACCIONES_ADMIN = {
  compras_crear:true,
  productos_crear:true, productos_editar:true, productos_eliminar:true,
  categorias_crear:true, categorias_editar:true, categorias_eliminar:true,
  clientes_crear:true, clientes_editar:true, clientes_eliminar:true,
  proveedores_crear:true, proveedores_editar:true, proveedores_eliminar:true,
  cotizaciones_crear:true, cotizaciones_gestionar:true,
  cxp_pagar:true, cxc_cobrar:true,
  devoluciones_crear:true,
  nomina_generar:true, nomina_pagar:true, nomina_eliminar:true,
  usuarios_crear:true, usuarios_editar:true, usuarios_eliminar:true,
  sucursales_crear:false, sucursales_editar:false, sucursales_eliminar:false,
};

// Rol 2 — Gerente: sin empleados, categorías, sucursales, nómina, libros fiscales
const MODULOS_GERENTE = {
  Home:true, Venta:true, Compra:true, Productos:true, Categorias:false,
  Clientes:true, Proveedores:true, Cotizaciones:true, ArqueoCaja:true,
  CuentasPorPagar:true, CuentasPorCobrar:true, Devoluciones:true,
  Nomina:false, LibrosFiscales:false, Auditoria:false, Usuario:false,
  Sucursal:false, reporte:true,
};
const ACCIONES_GERENTE = {
  ventas_descuento_general:true, ventas_descuento_producto:true, ventas_nc:true, ventas_cotizaciones:true, ventas_crear_cliente:true,
  compras_crear:true,
  productos_crear:true, productos_editar:true, productos_eliminar:true,
  categorias_crear:false, categorias_editar:false, categorias_eliminar:false,
  clientes_crear:true, clientes_editar:true, clientes_eliminar:true,
  proveedores_crear:true, proveedores_editar:true, proveedores_eliminar:true,
  cotizaciones_crear:true, cotizaciones_gestionar:true,
  cxp_pagar:true, cxc_cobrar:true,
  devoluciones_crear:true,
  nomina_generar:false, nomina_pagar:false, nomina_eliminar:false,
  usuarios_crear:false, usuarios_editar:false, usuarios_eliminar:false,
  sucursales_crear:false, sucursales_editar:false, sucursales_eliminar:false,
};

const DEFAULT_PERMISOS = {
  1: { modulos: { ...MODULOS_ADMIN },   acciones: { ...ACCIONES_ADMIN } },
  2: { modulos: { ...MODULOS_GERENTE }, acciones: { ...ACCIONES_GERENTE } },
  3: {
    modulos:  {},
    acciones: { ventas_descuento_general:false, ventas_descuento_producto:false, ventas_nc:true, ventas_cotizaciones:true, ventas_crear_cliente:true },
  },
};

export default {
  name: "AdministrarEmpleados",
  components: {
    btnGuardarModal,
    btnCerrarModal,
    ModalLoading,
  },
  data() {
    return {
      MODULOS_PERMISOS,
      ACCIONES_CAJERO,
      showConfirmModal: false,
      empleadoToDelete: null,
      titulo: "Usuarios",
      isLoading: false,
      showTooltip: false,
      searchQuery: "",
      searchSucursal: "default",
      id_usuario: 0,
      isModalOpen: false,
      isEditing: false,
      isPassEdit: true,
      showPassword: false,
      showConfirmPassword: false,
      selectedCountry: "HN",
      countryData: COUNTRY_CODES,
      phoneLength: 8,
      editIndex: null,
      currentPage: 1,
      pageSize: 10,
      sucursales: [],
      esCeo: false,
      roles: [],
      usuarioForm: {
        id_usuario: 0,
        nombre: "",
        apellido: "",
        nombre_usuario: "",
        correo: "",
        telefono: "",
        direccion: "",
        sucursal: "",
        password: "",
        confirmPassword: "",
        rol: "",
        permisos: { modulos: {}, acciones: {} },
      },
      empleados: [],
    };
  },
  computed: {
    puedeCrearUsuario()    { return hasAccionPermiso('usuarios_crear'); },
    puedeEditarUsuario()   { return hasAccionPermiso('usuarios_editar'); },
    puedeEliminarUsuario() { return hasAccionPermiso('usuarios_eliminar'); },
    esCajero() {
      return Number(this.usuarioForm.rol) === 3;
    },
    mostrarPermisos() {
      return [1, 2, 3].includes(Number(this.usuarioForm.rol));
    },
    filteredEmpleados() {
      return this.empleados
        .filter(
          (empleado) =>
            empleado.sucursales == this.searchSucursal ||
            this.searchSucursal === "default"
        )
        .filter(
          (empleado) =>
            empleado.nombre
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()) ||
            empleado.apellido
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()) ||
            empleado.nombre_usuario
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())
        );
    },
    paginatedEmpleados() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredEmpleados.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.filteredEmpleados.length / this.pageSize);
    },
  },
  watch: {
    'usuarioForm.rol'(newRol) {
      const rol = Number(newRol);
      if ([1, 2, 3].includes(rol)) {
        const def = DEFAULT_PERMISOS[rol];
        this.usuarioForm.permisos = {
          modulos:  { ...def.modulos },
          acciones: { ...def.acciones },
        };
      } else {
        this.usuarioForm.permisos = { modulos: {}, acciones: {} };
      }
    },
    searchQuery() {
      this.currentPage = 1;
    },
    searchSucursal() {
      this.currentPage = 1;
    },
  },
  methods: {
    updatePhoneValidation() {
      if (this.selectedCountry && this.countryData[this.selectedCountry]) {
        this.phoneLength = this.countryData[this.selectedCountry].length;
      }
    },
    openModal() {
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.$refs.nombreInput?.focus();
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.clearForm();
    },
    clearForm() {
      this.usuarioForm = {
        id_usuario: "",
        nombre: "",
        apellido: "",
        nombre_usuario: "",
        correo: "",
        telefono: "",
        direccion: "",
        sucursal: "",
        password: "",
        confirmPassword: "",
        rol: "",
        permisos: { modulos: {}, acciones: {} },
      };
      this.isEditing = false;
      this.editIndex = null;
      this.isPassEdit = true;
      this.showPassword = false;
      this.showConfirmPassword = false;
    },
    getRol(id_rol) {
      const rol = this.roles.find((rol) => rol.id_rol === id_rol);
      return rol ? rol.cargo : "Desconocido";
    },
    async getUsuarios(sucursales) {
      try {
        const esSoporte = (u) => u.nombre_usuario?.startsWith('sp_');
        if (sucursales.length === 1) {
          const data = await getUsuariosSucrusal(this.id_usuario, sucursales[0].id_sucursal);
          this.empleados = data.filter(u => !esSoporte(u));
          this.searchSucursal = sucursales[0].id_sucursal;
          this.usuarioForm.sucursal = sucursales[0].id_sucursal;
        } else {
          const data = await getUsuariosEmpresa(this.id_usuario);
          this.empleados = data.filter(u => !esSoporte(u));
        }
      } catch (error) {
        notis("error", "Error al obtener usuarios.");
      }
    },
    editarPassword() {
      this.isPassEdit = true;
    },
    async guardarUsuario() {
      if (this.isLoading) return;
      if (
        !(await validacionesUsuario.validarCampos(
          this.usuarioForm,
          this.isPassEdit,
          this.selectedCountry,
          this.isEditing
        ))
      ) {
        return;
      }

      this.isLoading = true;

      try {
        let response;
        let parametros;

        if (this.isEditing) {
          parametros = `/usuario/actualizar/${
            this.empleados[this.editIndex].id_usuario
          }`;
          response = await solicitudes.patchRegistroAuth(
            parametros,
            this.limpiarForm(this.usuarioForm)
          );

          if (response === true) {
            notis("success", "Actualizando datos del usuario...");
            Object.assign(this.empleados[this.editIndex], this.usuarioForm);
          } else {
            notis("error", response);
          }
        } else {
          // Verificar límite por rol según plan
          try {
            const plan = JSON.parse(localStorage.getItem('empresa_plan') || '{}');
            const limitesRoles = plan.limites_roles || {};
            const rolId = String(this.usuarioForm.rol);
            const maxParaRol = limitesRoles[rolId];
            if (maxParaRol) {
              const countRol = this.empleados.filter(e => String(e.id_rol) === rolId).length;
              if (countRol >= maxParaRol) {
                const nombreRol = this.roles.find(r => String(r.id_rol) === rolId)?.cargo || `Rol ${rolId}`;
                notis('error', `Límite alcanzado: máximo ${maxParaRol} usuario(s) con rol "${nombreRol}" en tu plan.`);
                this.isLoading = false;
                return;
              }
            }
          } catch { /* plan check — ignore */ }

          parametros = `/usuario/crear`;
          response = await solicitudes.postRegistroAuth(
            parametros,
            this.limpiarForm(this.usuarioForm)
          );

          if (response && response.id_usuario) {
            notis("success", "Usuario guardado correctamente...");
            this.empleados.push(response);
          } else {
            throw new Error(response?.message || "Error al crear el usuario");
          }
        }

        this.closeModal();
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    async deleteUsuariol(empleado) {
      if (!this.showConfirmModal) {
        if (empleado.id_usuario === this.id_usuario) {
          notis("warning", "No puedes desactivar tu propio usuario");
          return;
        }
        this.empleadoToDelete = empleado;
        this.showConfirmModal = true;
        return;
      }

      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const parametros = `/usuario/desactivar/${this.empleadoToDelete.id_usuario}`;
        const response = await solicitudes.desactivarRegistroAuth(parametros, {
          estado: false,
        });

        if (response === true) {
          const index = this.empleados.findIndex(
            (e) => e.id_usuario === this.empleadoToDelete.id_usuario
          );
          if (index !== -1) {
            this.empleados.splice(index, 1);
          }
          notis("success", "Usuario eliminado correctamente");
        }
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
        this.showConfirmModal = false;
        this.empleadoToDelete = null;
      }
    },

    cancelDelete() {
      this.showConfirmModal = false;
      this.empleadoToDelete = null;
    },

    editEmpleado(empleado) {
      this.editIndex = this.empleados.findIndex(
        (item) => item.id_usuario === empleado.id_usuario
      );
      this.usuarioForm = { ...empleado };
      this.usuarioForm.sucursal = empleado.sucursales;
      this.usuarioForm.rol = empleado.id_rol;
      this.isEditing = true;
      this.isPassEdit = false;
      this.openModal();
      // El watcher de rol se ejecuta en el next tick y pone defaults.
      // Esperamos un tick más para sobreescribir con los permisos reales del usuario.
      this.$nextTick(() => {
        if (empleado.permisos?.modulos) {
          this.usuarioForm.permisos = {
            modulos:  { ...empleado.permisos.modulos },
            acciones: { ...(empleado.permisos.acciones || {}) },
          };
        } else {
          const rol = Number(empleado.id_rol);
          const def = DEFAULT_PERMISOS[rol];
          this.usuarioForm.permisos = def
            ? { modulos: { ...def.modulos }, acciones: { ...def.acciones } }
            : { modulos: {}, acciones: {} };
        }
      });
    },

    limpiarForm(formulario) {
      const rol = Number(formulario.rol);
      return {
        nombre: formulario.nombre,
        apellido: formulario.apellido,
        nombre_usuario: formulario.nombre_usuario,
        correo: formulario.correo,
        telefono: formulario.telefono,
        direccion: formulario.direccion,
        id_sucursal: Array.isArray(formulario.sucursal) ? formulario.sucursal[0] : formulario.sucursal,
        contraseña: formulario.password,
        id_rol: formulario.rol,
        permisos: [1, 2, 3].includes(rol) ? formulario.permisos : null,
      };
    },

    changeFavicon(iconPath) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = iconPath;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },
  async mounted() {
    this.isLoading = true;
    setPageTitle("Usuarios");

    try {
      this.id_usuario = await solicitudes.solicitarUsuarioToken();
      this.esCeo = await esCeo(this.id_usuario);
      this.sucursales = await getSucursalesbyEmmpresaSumm(this.id_usuario);
      await this.getUsuarios(this.sucursales);
      this.roles = await getRolesUsuarioPage();
    } catch (error) {
      notis("error", error.message);
    } finally {
      this.isLoading = false;
    }
    const _s = getSocket();
    if (_s) {
      this._wsRefresh = async () => { if (this.id_usuario && this.sucursales) await this.getUsuarios(this.sucursales); };
      _s.on('usuarios:refresh', this._wsRefresh);
    }
  },
  beforeUnmount() {
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('usuarios:refresh', this._wsRefresh);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* {
  font-family: "Montserrat", sans-serif;
  box-sizing: border-box;
}

.info-icon {
  cursor: pointer;
  margin-right: 5px;
  font-size: 16px;
  color: #666;
}

.tooltip {
  position: absolute;
  left: 0;
  top: 28px; /* Ajustado para que aparezca debajo del label */
  background-color: #333;
  color: white;
  border-radius: 6px;
  padding: 10px;
  font-size: 14px;
  width: 300px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tooltip::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 10px;
  border-width: 0 5px 5px 5px;
  border-style: solid;
  border-color: transparent transparent #333 transparent;
}

.modal {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-usuario {
  background: white;
  border-radius: 12px;
  width: 80%;
  max-width: 1100px;
  max-height: 90vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 20px;
  overflow: hidden;
}

.modal-header {
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
}

#AddUsuarioModal,
#BtnCerrar {
  width: 80%;
}

.modal-body {
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 24px;
  overflow-y: auto;
}

.form-row {
  margin-bottom: 20px;
}

.form-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 20px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.contenedor {
  width: 45%;
}

/* Form Groups */
.form-group {
  margin-bottom: 20px;
  position: relative; /* Añadido para posicionamiento del tooltip */
}

.form-group label {
  display: block;
  margin-bottom: 1px;
  color: #333;
  font-weight: 500;
}

.modal-confirm {
  background: white;
  border-radius: 12px;
  width: 25%;
  max-width: 1000px;
  max-height: 90vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 20px;
  overflow: hidden;
}

.modal-body-confirm {
  padding: 24px;
  overflow-y: auto;
  background-color: white;
}

.dark .modal-body-confirm {
  background-color: #333;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: white;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #c09d62;
  box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
}

/* Dark Mode */
.dark .modal-categoria {
  background-color: #2d2d2d;
}

.dark .modal-header,
.dark .modal-footer {
  background-color: #1e1e1e;
  border-color: #404040;
}

.dark .modal-header h2 {
  color: #fff;
}

.dark .form-group label {
  color: #fff;
}

.dark .form-group input,
.dark .form-group textarea,
.dark .form-group select {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.btn {
  padding: 8px 16px;
  margin: 4px;
  border: none;
  cursor: pointer;
}

.btn-primary {
  background-color: #c09d62;
  color: white;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #a38655;
  color: white;
}

/* Botones de fila — compactos 32x32 */
.accion-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  transition: opacity 0.2s, transform 0.15s;
  margin: 2px;
}
.accion-btn:hover { opacity: 0.85; transform: scale(1.08); }
.accion-editar  { background-color: #f59e0b; color: #1a1a1a; }
.accion-eliminar { background-color: #ef4444; }

.opciones {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}

.busqueda {
  padding: 10px;
  font-size: 14px;
  border-radius: 10px;
  border-width: 0.5px;
  width: 100%;
  max-width: 350px;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #c09d62;
  box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
  transition: all 0.3s ease;
}

.registros {
  display: flexbox;
  height: 100%;
  align-items: end;
}

#btnAdd {
  background-color: #c09d62;
  font-size: 16px;
  width: auto;
  min-width: 170px;
  height: 40px;
  border-radius: 10px;
  color: black;
  font-weight: bold;
  white-space: nowrap;
}

.export-button {
  margin: 0;
}

#btnAdd:hover {
  background-color: #a38655;
  transform: scale(1.05);
  transition: all 0.3s ease;
}

#btnCerrarM {
  margin-left: 28rem;
}

#btnEditar {
  font-size: 18px;
  width: 50px;
  height: 40px;
  border-radius: 10px;
}

#btnEditar:hover {
  background-color: #e8af06;
  transform: scale(1.05);
  transition: all 0.3s ease;
}

#btnEliminar {
  font-size: 18px;
  width: 50px;
  height: 40px;
  border-radius: 10px;
  color: black;
}

#btnEliminar:hover {
  background-color: #b72433;
  transform: scale(1.05);
  transition: all 0.3s ease;
}

.dark #btnAdd {
  background-color: #c09d62;
  color: black;
}

.dark #btnAdd:hover {
  background-color: #a38655;
}

.dark #btnEditar {
  background-color: #ffc107;
  color: black;
}

.dark #btnEditar:hover {
  background-color: #e8af06;
}

.dark #btnEliminar {
  background-color: #dc3545;
  color: black;
}

.dark #btnEliminar:hover {
  background-color: #b72433;
}

.empleados-wrapper {
  padding: 16px;
  width: 100%;
  overflow-x: hidden;
}

.table-container {
  width: 100%;
  border-radius: 0;
  border: 1px solid #e2e8f0;
  margin-top: 16px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.table {
  width: 100%;
  min-width: 800px;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.table th,
.table td {
  padding: 8px;
}

.table thead th {
  background-color: none;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.table tbody td {
  text-align: center;
  border-top: 1px solid #ddd;
}

/* Estilos para la paginación */
.loading-indicator,
.no-data {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: #666;
}

.no-data {
  background-color: #f8f9fa;
  border-radius: 4px;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  margin-top: auto;
}

.pagination-info {
  color: #6c757d;
}

.pagination-container {
  display: flex;
  gap: 5px;
}

.pagination-button {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background-color: white;
  cursor: pointer;
  border-radius: 4px;
  min-width: 40px;
  transition: all 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
  background-color: #e9ecef;
}

.pagination-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Personalización del scroll */
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

.custom-select {
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  padding: 10px;
  background-color: #fff;
  cursor: pointer;
  width: 60%;
  min-width: 400px;
}

/* Estilos del teléfono */
.phone-input-container {
  display: flex;
  gap: 8px;
}

.phone-input-container select {
  width: 30%;
}

.phone-input-container input {
  width: 70%;
}

/* Media Queries */
@media screen and (max-width: 768px) {
  .modal-body {
    flex-direction: column;
  }

  .contenedor {
    width: 100%;
    margin-bottom: 20px;
  }

  .modal-usuario {
    min-width: 90%;
    max-width: 95%;
  }

  .opciones {
    flex-direction: column;
    align-items: stretch;
  }

  .busqueda,
  .custom-select,
  #btnAdd,
  .export-button {
    width: 100%;
    max-width: none;
    min-width: 0;
    margin: 8px 0;
  }

  #btnEditar,
  #btnEliminar {
    width: 40px;
    height: 35px;
    font-size: 14px;
    padding: 8px;
  }

  .pagination-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .pagination-container {
    justify-content: center;
    flex-wrap: wrap;
  }

  .table-container {
    margin: 10px 0;
    border-radius: 8px;
    overflow-x: auto;
  }

  .table {
    min-width: 650px; /* Ancho mínimo para asegurar que el contenido sea legible */
  }

  .table th,
  .table td {
    padding: 10px 8px;
    font-size: 14px;
  }

  /* Botones de acción en tabla */
  .accion-btn { width: 30px; height: 30px; font-size: 13px; }
}

@media screen and (max-width: 480px) {
  .modal-usuario {
    width: 95%;
    padding: 15px;
  }

  .table thead th,
  .table tbody td {
    padding: 6px;
    font-size: 14px;
  }

  .form-group {
    margin-bottom: 12px;
  }

  .form-group input,
  .password-wrapper input {
    width: 100%;
  }

  .table-container {
    margin: 8px 0;
    border-radius: 6px;
  }

  /* Convertir la tabla en tarjetas para móvil */
  .table {
    display: block;
    min-width: unset;
  }

  .table thead {
    display: none; /* Ocultar el encabezado en móvil */
  }

  .table tbody {
    display: block;
  }

  .table tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
    background: #fff;
  }

  .table td {
    display: grid;
    grid-template-columns: 40% 60%;
    padding: 8px;
    text-align: left;
    border: none;
  }

  .table td::before {
    content: attr(data-label);
    font-weight: bold;
    margin-right: 1rem;
  }

  /* Ajustar botones de acción */
  .table td:last-child {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 12px;
  }

  #btnEditar,
  #btnEliminar {
    width: 36px;
    height: 36px;
    padding: 6px;
    font-size: 14px;
  }

  /* Estilos para modo oscuro */
  .dark .table tr {
    background: #2d2d2d;
    border-color: #404040;
  }
}

/* Ajustes para móviles pequeños */
@media screen and (max-width: 360px) {
  .table td {
    grid-template-columns: 100%;
  }

  .table td::before {
    margin-bottom: 4px;
  }

  .table td:last-child {
    justify-content: center;
  }

  #btnEditar,
  #btnEliminar {
    width: 32px;
    height: 32px;
    padding: 4px;
    font-size: 12px;
  }
}

/* Modo Oscuro */
.dark .empleados-wrapper {
  background-color: #1e1e1e;
  color: #fff;
}

.dark .busqueda {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .custom-select {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .table-container {
  background-color: #1e1e1e;
  border-color: #374151;
}

.dark .table {
  background-color: #1e1e1e;
}

.dark .table thead {
  background-color: #111827;
}

.dark .table th {
  background-color: #111827;
  color: #e5e7eb;
  border-bottom-color: #374151;
}

.dark .table td {
  color: #e5e7eb;
  border-bottom-color: #374151;
}

.dark .table tbody tr:hover {
  background-color: #1f2937;
}

.dark .modal-usuario {
  background-color: #2d2d2d;
  color: #fff;
}

/* ── Permisos matrix ───────────────────────────────────── */
.permisos-section {
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
}
.permisos-titulo {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 4px;
}
.permisos-desc {
  font-size: 0.8rem;
  color: #666;
  margin: 0 0 12px;
}
.permisos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 8px;
}
.permiso-modulo {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 12px;
  background: #fff;
}
.permiso-modulo-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}
.permiso-acciones {
  margin-top: 6px;
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.permiso-accion-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  cursor: pointer;
  color: #444;
}
.permiso-check {
  cursor: pointer;
}

/* Dark mode permisos */
.dark .permisos-section {
  background: #1e1e2e;
  border-top-color: #3f3f5a;
}
.dark .permiso-modulo {
  background: #2d2d42;
  border-color: #4a4a6a;
}
.dark .permisos-desc {
  color: #aaa;
}
.dark .permiso-accion-label {
  color: #ccc;
}

.dark .form-group input,
.dark .form-group select {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.dark .pagination-wrapper {
  border-color: #404040;
}

.dark .pagination-info {
  color: #aaa;
}

.dark .pagination-button {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .pagination-button:hover:not(:disabled) {
  background-color: #383838;
}

.dark .loading-indicator,
.dark .no-data {
  color: #aaa;
  background-color: #2d2d2d;
}

.dark .table-container::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.dark .table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
}

.dark .table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-wrapper input {
  padding-right: 40px;
  width: 100%;
}

.toggle-password {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: #666;
  padding: 0;
  display: flex;
  align-items: center;
}

.toggle-password:disabled {
  color: #999;
  cursor: not-allowed;
}

.toggle-password:hover:not(:disabled) {
  color: #333;
}

/* Estilos para modo oscuro */
.dark .toggle-password {
  color: #aaa;
}

.dark .toggle-password:hover:not(:disabled) {
  color: #fff;
}

.dark .toggle-password:disabled {
  color: #666;
}

.dark .tooltip {
  background-color: #1e1e1e;
  border: 1px solid #404040;
}

.dark .tooltip::before {
  border-color: transparent transparent #1e1e1e transparent;
}

.dark .info-icon {
  color: #aaa;
}
</style>
